if (!customElements.get('ca-seasonal-hero')) {
  customElements.define('ca-seasonal-hero', class extends HTMLElement {
    connectedCallback() {
      const slides = [...this.querySelectorAll('.ca-season-feature')];
      const choices = [...this.querySelectorAll('.ca-season-choice')];
      if (!slides.length) return;
      const stage = this.querySelector('.ca-season-stage');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const interval = Math.max(4000, Number(this.dataset.interval) || 6500);
      let current = 0;
      let visible = true;
      let editing = false;
      let touchStart;
      let timer;
      const schedule = () => {
        clearTimeout(timer);
        const focusedLink = this.querySelector('.ca-season-feature a:focus');
        if (slides.length > 1 && !motion.matches && visible && !document.hidden && !editing && !focusedLink && !touchStart) {
          timer = setTimeout(() => show(current + 1), interval);
        }
      };
      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        choices.forEach((choice, i) => choice.setAttribute('aria-pressed', String(i === current)));
        const nextImage = slides[(current + 1) % slides.length].querySelector('img');
        if (nextImage) nextImage.loading = 'eager';
        schedule();
      };
      choices.forEach((choice, i) => choice.addEventListener('click', () => show(i), options));
      this.addEventListener('focusin', schedule, options);
      this.addEventListener('focusout', () => queueMicrotask(schedule), options);
      this.addEventListener('keydown', event => {
        if (!event.target.closest('.ca-season-controls') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        show(current + (event.key === 'ArrowRight' ? 1 : -1));
        choices[current].focus();
      }, options);
      stage.addEventListener('touchstart', event => {
        const touch = event.changedTouches[0];
        touchStart = { x: touch.clientX, y: touch.clientY };
        schedule();
      }, { ...options, passive: true });
      stage.addEventListener('touchend', event => {
        if (!touchStart) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - touchStart.x;
        const dy = touch.clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
        else schedule();
      }, options);
      stage.addEventListener('touchcancel', () => { touchStart = null; schedule(); }, options);
      document.addEventListener('visibilitychange', schedule, options);
      motion.addEventListener('change', schedule, options);
      this.addEventListener('shopify:block:select', event => {
        const index = slides.findIndex(slide => slide.contains(event.target));
        if (index < 0) return;
        editing = true;
        show(index);
      }, options);
      this.addEventListener('shopify:block:deselect', () => { editing = false; schedule(); }, options);
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); });
      observer.observe(this);
      this.querySelector('.ca-season-controls').hidden = slides.length < 2;
      this.cleanup = () => { controller.abort(); observer.disconnect(); clearTimeout(timer); };
      show(0);
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
